module.exports = __webpack_public_path__ + "img/joinZigZagWhite.bfcc4faf.svg";